
import { useState } from 'react';
import LoadingButton from './LoadingButton';
import { httpGet } from '../../modules/Backend';
import HttpStatusCodes from '../../modules/HttpStatusCodes';
import iconDownload from "../../assets/icons/icon-download-white.svg";
import iconEye from "../../assets/icons/icon-eye.svg"

export interface IDownloadButton {
  id: string | undefined,
  entityName: string | undefined
}

const DownloadViewWidget = ({ id, entityName }: IDownloadButton) => {

  const [downloading, setDownloading] = useState(false);
  const [viewing, setViewing] = useState(false);

  async function download() {
    setDownloading(true);
    const params = new URLSearchParams();
    params.append("id", id!);

    if (!id) {
      return;
    }

    const response = await httpGet(`api/${entityName}/fileView?id=${id}`);
    if (response.status === HttpStatusCodes.Ok) {
      const blobResponse = await fetch(response.data.url);
      if (blobResponse.ok) {
        const blob = await blobResponse.blob();
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = `${response.data.fileName}${response.data.fileType}`;
        document.body.appendChild(link);

        link.click();
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
    setDownloading(false);
  }

  async function view() {
    setViewing(true);
    const params = new URLSearchParams();
    params.append("id", id!);

    if (!id) {
      return;
    }

    const response = await httpGet(`api/${entityName}/fileView?id=${id}`);
    if (response.status === HttpStatusCodes.Ok) {
      window.open(response.data.url, "_blank");
    }

    setViewing(false);
  }

  return (
    <div className='display--flex gap--s justifyContent--center'>
      <LoadingButton
        buttonText='View'
        loadingText='' // If we set loading text it will increase the button size which looks awful in adobe aria lists as the table will resize
        isDisabled={viewing}
        isLoading={viewing}
        className='button button--secondary button--small button--with-icon'
        onPress={view}
      >
        <img src={iconEye} />
      </LoadingButton>

      <LoadingButton
        buttonText='Download'
        loadingText='' // If we set loading text it will increase the button size which looks awful in adobe aria lists as the table will resize
        isDisabled={downloading}
        isLoading={downloading}
        className='button button--small button--primary button--with-icon'
        onPress={download}
      >
        <img src={iconDownload} />
      </LoadingButton>
    </div>
  );
};

export default DownloadViewWidget;